// ** Initial State
const initialState = {
  export: [],
  allExhibitors: [],
  exhibitor: null,
  allmembership:[],
  data:null,
  delete:null,
  exhibitorDataWithPagination: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
    },
  pageLoader: true,
  editPageLoader: true,
  sponsorShipLevelDetails: null,
  exhibitorPricing: null,
  updateSponsorship: null,
  deleteInvitedComplimentry:null,
  deleteExhibitor: null,
  deleteExhibitorBooth: null
}

const exhibitors = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EXHIBITORS_ATTENDEES_EXPORT':
      return { ...state, export: action.data }
    case 'GET_ALL_EXHIBITORS':
      return { ...state, allExhibitors: action.data }
    case 'GET_EXHIBITOR':
      return { 
        ...state, 
        exhibitor: action.data,
        editPageLoader: false
       }
    case 'SET_EXHIBITOR':
      return { ...state, exhibitor: action.data }
      case 'DELETE_EXHIBITOR':
      return { ...state, allExhibitors: action.data }
    case 'CREATE_EXHIBITOR':
      return { ...state, exhibitor: action.data }
    case 'UPDATE_EXHIBITOR':
      return { ...state, data: action.data }
    case 'UPDATE_SPONSORSHIP':
      return { ...state, data: action.data }
    case 'REMOVE_EXHIBITOR':
      return { ...state, exhibitor: null}
    case 'GET_MEMBERSHIP':
        return {...state, allmembership: action.data}
    case 'DELETE_EXHIBITOR_ADDTIONAL_ADMIN':
      return {...state, delete: action.data}
    case 'GET_SPONSORSHIP_LEVEL_EXHIBITOR':
      return {...state, sponsorShipLevelDetails: action.data}
    case 'UPDATE_SPONSORSHIP_LEVEL_EXHIBITOR':
      return {...state, updateSponsorship: action.data}
    case 'GET_AMOUNT_FOR_EXHIBITOR':
      return {...state, exhibitorPricing: action.data}
    case 'GET_EXHIBITOR_WITH_PAGINATION':
      return { ...state, exhibitorDataWithPagination:action.data,pageLoader:false}
    case 'DELETE_COMPLIMENTRY_INVITE':
      return { ...state, deleteInvitedComplimentry: action.data }
    case 'DELETE_EXHIBITOR_DETAILS':
      return { ...state, deleteExhibitor: action.data }
    case 'DELETE_EXHIBITOR_BOOTH_DETAILS':
      return { ...state, deleteExhibitorBooth: action.data }
    case 'CLEAR_DATA':
      return {...state, exhibitor:null}
    default:
      return { ...state }
  }
}
export default exhibitors
